require('babelify/polyfill');

import Boot from './Boot.js';
import Preloader from './utils/Preloader.js';
import Game from './Game.js';
import Config from './utils/Config.js';
import Intro from './Intro';
import Utils from './utils/Utils.js';

Config.START_ORIENTATION = window.innerWidth > window.innerHeight ? Config.LANDSCAPE : Config.PORTRAIT;

function initGame()
{
    Config.ORIENTATION = Config.START_ORIENTATION;
    console.log('Config.ORIENTATION:', Config.ORIENTATION, Config.START_ORIENTATION);

    // detect layout
    Config.MobileDevice = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    Config.ORIENTATION = Config.MobileDevice ? ((window.innerWidth > window.innerHeight) ? Config.LANDSCAPE : Config.PORTRAIT) : Config.DESKTOP;

    if (Config.MobileDevice)
    {
        Config.GAME_WIDTH = (Config.START_ORIENTATION === Config.PORTRAIT ? Config.PORTRAIT_GAMEWIDTH : Config.LANDSCAPE_GAMEWIDTH);
        Config.GAME_HEIGHT = (Config.START_ORIENTATION === Config.PORTRAIT ? Config.PORTRAIT_GAMEHEIGHT : Config.LANDSCAPE_GAMEHEIGHT);
    }
    else
    {
        Config.GAME_WIDTH = Config.DESKTOP_GAMEWIDTH;
        Config.GAME_HEIGHT = Config.DESKTOP_GAMEHEIGHT;
    }

    const game = new Phaser.Game(Config.GAME_WIDTH, Config.GAME_HEIGHT, Phaser.AUTO, 'game', null, true);
    
    // add game states
    game.state.add('Boot', Boot);
    game.state.add('Preloader', Preloader);
    game.state.add('Intro', Intro);
    game.state.add('Game', Game);

    // start the Boot state
    game.state.start('Boot');
}

function windowOnLoadHandler()
{
    if (window.leanderGMApi && window.leanderGMApi.initialized)
    {
        // suppress LeanderAPI console.log calls (put false to suppress)
        Utils.leanderAPILogsEnabled(true);
        initGame();
    }
    else
    {
        setTimeout(windowOnLoadHandler, 1000);
    }
}

function windowOnResizeHandler()
{
    Config.MobileDevice = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    const newLayout = Config.MobileDevice ? ((window.innerWidth > window.innerHeight) ? Config.LANDSCAPE : Config.PORTRAIT) : Config.DESKTOP;
    
    if (newLayout === Config.ORIENTATION)
    {
        return;
    }
            
    Config.ORIENTATION = newLayout;
    
    if (Config.ORIENTATION === Config.PORTRAIT)
    {
        Config.GAME_WIDTH = Config.PORTRAIT_GAMEWIDTH;
        Config.GAME_HEIGHT = Config.PORTRAIT_GAMEHEIGHT;        
    } 
    else if (Config.ORIENTATION === Config.LANDSCAPE)
    {
        Config.GAME_WIDTH = Config.LANDSCAPE_GAMEWIDTH;
        Config.GAME_HEIGHT = Config.LANDSCAPE_GAMEHEIGHT;       
    } 
    else
    {
        Config.GAME_WIDTH = Config.DESKTOP_GAMEWIDTH;
        Config.GAME_HEIGHT = Config.DESKTOP_GAMEHEIGHT;    
    } 

    if (!window.game || !window.game.game)
    {
        return;
    }

    window.game.game.width = Config.GAME_WIDTH;
    window.game.game.height = Config.GAME_HEIGHT;

    if (window.game.game.renderType === Phaser.WEBGL)
    {
        window.game.game.renderer.resize(Config.GAME_WIDTH, Config.GAME_HEIGHT);
    }

    window.game.reload();
}

window.onload = windowOnLoadHandler;
//window.onresize = windowOnResizeHandler;
